"use client";

import { useContext } from "react";
import { AnnouncerContext } from "@/lib/hooks/use-announcer";

export function Announcer() {
  const context = useContext(AnnouncerContext);

  if (!context) {
    throw new Error("Announcer must be used within AnnouncerProvider");
  }

  return (
    <div
      data-slot="announcer"
      aria-live="assertive"
      aria-atomic="true"
      className="sr-only"
    >
      {context.message}
    </div>
  );
}
